// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"255":"458d4b41","497":"02353def","542":"83a5615d","815":"a24b32f2","995":"44254477"}[chunkId] + ".css";
};